import React, { FC, useEffect } from 'react'
import styled from 'styled-components'

import PromoCodeContainer from '../../components/buy/promo_code/PromoCodeContainer'
import { OrderSummary } from '../../components/buy/summary/OrderSummary'
import { CartFragment } from '../../graphql/magento'
import { latestEScriptErrors$ } from '../../lib/escript/state'
import LeftHalfLayout from './LeftHalfLayout'
import RightHalfLayout from './RightHalfLayout'

export interface CartLayoutProps {
  cart: CartFragment
}

const StyledLeftHalfLayout = styled(LeftHalfLayout)`
  && {
    padding: 0;
    @media (min-width: 600px) {
      padding-bottom: 30px;
    }
  }
`

const CartLayout: FC<CartLayoutProps> = ({ children, cart }) => {
  useEffect(() => {
    const subscription = latestEScriptErrors$.subscribe()
    return () => subscription.unsubscribe()
  }, [])

  return (
    <>
      <StyledLeftHalfLayout>{children}</StyledLeftHalfLayout>
      <RightHalfLayout>
        <OrderSummary cart={cart} />
        <PromoCodeContainer cart={cart} />
      </RightHalfLayout>
    </>
  )
}

export default CartLayout
